export const ProductionSimulationInstructionStage = (
	json: IProductionSimulationInstructionStage,
): IProductionSimulationInstructionStageModel => {
	const {
		position_id,
		position_instructions_downloaded_at,
		position_products_count,
		position_workers_count,
		stage_long_name,
		stage_name,
		simulation_position_machine_short_name,
		...rest
	} = json

	return {
		...rest,
		positionID: position_id,
		positionInstructionsDownloadedAt: position_instructions_downloaded_at,
		positionProductsCount: position_products_count,
		positionWorkersCount: position_workers_count,
		simulationPositionMachineShortName: simulation_position_machine_short_name,
		stageLongName: stage_long_name,
		stageName: stage_name,
	}
}

export const ProductionSimulationInstruction = (
	json: IProductionSimulationInstruction,
): IProductionSimulationInstructionModel => {
	const {
		is_added,
		production_simulation_id,
		production_socket_id,
		socket_workers,
		socket_count,
		products_count,
		socket_simulation_start_time,
		socket_simulation_end_time,
		socket_name,
		stages,
		...rest
	} = json

	return {
		...rest,
		isAdded: is_added,
		productionSimulationID: production_simulation_id,
		productionSocketID: production_socket_id,
		socketWorkers: socket_workers,
		socketCount: socket_count,
		productsCount: products_count,
		socketSimulationStartTime: socket_simulation_start_time ? new Date(socket_simulation_start_time) : null,
		socketSimulationEndTime: socket_simulation_end_time ? new Date(socket_simulation_end_time) : null,
		socketName: socket_name,
		stages: stages.map(ProductionSimulationInstructionStage),
	}
}

export const ProductionSimulationInstructionGenerateList = (
	json: IProductionSimulationInstructionGenerateListResponse,
): IProductionSimulationInstructionGenerateListModel => {
	const { id, status, path_to_download, created_at, downloaded } = json

	return {
		id,
		status,
		downloaded,
		pathToDownload: path_to_download,
		createdAt: created_at ? new Date(created_at) : null,
	}
}
